import { cn } from '@/lib/utils';

interface SpinnerProps {
  /** Size of the spinner */
  size?: 'sm' | 'md' | 'lg';
  /** Additional CSS classes */
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-3',
};

/**
 * Animated loading spinner component with bioluminescent glow.
 *
 * @example
 * ```tsx
 * <Spinner size="md" />
 * ```
 */
export function Spinner({ size = 'md', className }: SpinnerProps): React.ReactElement {
  return (
    <div
      className={cn(
        'animate-spin rounded-full',
        'border-biolume-cyan/20 border-t-biolume-cyan',
        'shadow-[0_0_10px_rgba(34,211,238,0.3)]',
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}
